var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash",class:{ fadeout: !_vm.isLoading }},[_c('app-logo',{staticClass:"splash__logo",attrs:{"theme-switch":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }